type UploadFileContainerProps = {
  children: React.ReactNode
}

export const UploadFileContainer = ({ children }: UploadFileContainerProps) => {
  return <div>{children}</div>
}
